<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<script>

import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import NextStepButton from '@/views/SaaS/widget/NextStepButton.vue'
import { updateRestaurantInfo } from '@/model/dataLayer/service/otherService'
import { getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import { useStore } from '@/model/dataLayer/api/SaaS/storeService'

export default {
  name: 'InputRestaurantInfo',
  components: {
    NextStepButton,
    SaaSChildPageContainer
  },
  data: function () {
    return {
      valid: true,
      allRules: [
        v => !!v || this.$t('required')
      ],
      storeInfoList: {
        name: '',
        adress1: '',
        adress2: '',
        postCode: '',
        city: '',
        state: '',
        taxNumber: '',
        telephone: '',
        latitude: '',
        longitude: '',
        inhalterName: '',
        inhalterLastName: '',
        inhalterTitle: '',
        emailAddress: '',
        totalRound: '10',
        maxDineTime: '120',
        roundTime: '12',
        roundDishCount: '10',
        takeawayPriceModification: '0',
        childRoundDishCount: '1',
        tableColor: '',
        callColor: '',
        bonLogo: '',
        buffetLogo: '',
        currentlyOpening: '',
        letterOnExternalOrder: '',
        ZBonEmail: ''
      }
    }
  },
  methods: {
    async next () {
      if (this.$refs.form.validate()) {
        await updateRestaurantInfo(this.storeInfoList)
        await useStore(await getCurrentStoreId())
        await this.$router.push({ name: 'download-guide' })
      }
    }
  }
}
</script>

<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <saa-s-child-page-container>
      <template #title>
        <div class="text-h3">
          {{ $t('PleaseEnterBusinessInformation') }}
        </div>
        <div class="text-body-2 mt-2 text--secondary">
          {{ $t('PleaseEnterBusinessInformationHint') }}
        </div>
        <div class="text-subtitle-2 mt-8">
          {{ $t('address') }}
        </div>
      </template>

      <div
        class="mt-4"
        style="width: 100%"
      >
        <div>
          <v-text-field
            v-model="storeInfoList.name"
            dense
            :label="$t('NameOfCompany')"
            :rules="allRules"
            filled
          />
        </div>
        <div>
          <v-text-field
            v-model="storeInfoList.adress1"
            dense
            :label="$t('AddressLine1')"
            :rules="allRules"
            filled
          />
        </div>
        <div>
          <v-text-field
            v-model="storeInfoList.adress2"
            dense
            :label="$t('AddressLine2')"
            filled
          />
        </div>
        <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 12px">
          <div>
            <v-text-field
              v-model="storeInfoList.city"
              dense
              :label="$t('city')"
              :rules="allRules"
              filled
            />
          </div>
          <div>
            <v-text-field
              v-model="storeInfoList.postCode"
              dense
              :label="$t('postCode')"
              :rules="allRules"
              filled
            />
          </div>
        </div>
        <div>
          <v-text-field
            v-model="storeInfoList.telephone"
            dense
            :label="$t('telephone')"
            :rules="allRules"
            filled
          />
        </div>
      </div>
      <div class="text-subtitle-2 mt-8">
        {{ $t('LegalForm') }}
      </div>
      <div
        class="mt-4"
        style="width: 100%"
      >
        <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 12px">
          <div>
            <v-text-field
              v-model="storeInfoList.inhalterName"
              dense
              :label="$t('inhalterName')"
              :rules="allRules"
              filled
            />
          </div>
          <div>
            <v-text-field
              v-model="storeInfoList.inhalterLastName"
              dense
              :label="$t('inhalterLastName')"
              :rules="allRules"
              filled
            />
          </div>
        </div>

        <div>
          <v-text-field
            v-model="storeInfoList.taxNumber"
            :label="$t('taxNumber')"
            :rules="allRules"
            dense
            filled
          />
        </div>
        <div>
          <v-text-field
            v-model="storeInfoList.emailAddress"
            :label="$t('emailAddress')"
            :rules="allRules"
            dense
            filled
          />
        </div>
      </div>
      <template #actions>
        <next-step-button @next="next">
          {{ $t('confirm') }}
        </next-step-button>
      </template>
    </saa-s-child-page-container>
  </v-form>
</template>

<style scoped>

</style>
